import React from 'react';

export const formatErrorMessage = errorObject => {
  const errorMessages = Object.values(errorObject);
  const flattenedMessageArray = [].concat(...errorMessages);

  const toastContent = (
    <ul>
      {flattenedMessageArray.map(message => (
        <li key={message}>{message}</li>
      ))}
    </ul>
  );

  return toastContent;
};
